export default "__VITE_ASSET__62e8df4a__"